import axios from 'axios';
import { Message, Loading } from 'element-ui';
import router from './../router/index';
import { getCookie } from '../util/cookie';
let loginCode=400001;
let loginRouter="/login"

// 创建axios实例并配置全局参数
const axiosInstance = axios.create({
  baseURL: '', // 设置默认的API基础路径
  headers: { 'Content-Type': 'application/json' },
});

// 请求拦截器，统一设置token
axiosInstance.interceptors.request.use(config => {
  const token = getCookie('token');
  if (token) {
    config.headers['token'] = token;
  }
  return config;
}, error => {
  Message.error('请求错误');
  return Promise.reject(error);
});

// 响应拦截器，统一处理响应错误
axiosInstance.interceptors.response.use(response => {
  const data = response.data;
  if (data.code !== 0) {
    errorTip(data);
    return Promise.reject(data);
  }
  return data.data;
}, error => {
  console.error('响应错误', error);
  Message.error('系统异常');
  return Promise.reject(error);
});

// 通用请求函数
function request(method, url, data = null, callback, ...params) {
  let loadingInstance = Loading.service({ target: 'body', fullscreen: false });
  let formattedUrl = params.reduce((acc, item, index) => acc.replace(`\${param${index}}`, item), url);

  axiosInstance({
    method,
    url: formattedUrl,
    data,
  })
    .then(callback)
    .catch(() => {})
    .finally(() => loadingInstance.close());
}

// 导出请求方法
export function getRequest(url, callback, ...params) {
  request('get', url, null, callback, ...params);
}

export function postRequest(url, data, callback, ...params) {
  request('post', url, data, callback, ...params);
}

export function putRequest(url, data, callback, ...params) {
  request('put', url, data, callback, ...params);
}

export function deleteRequest(url, callback, ...params) {
  request('delete', url, null, callback, ...params);
}

// 错误提示函数
function errorTip(data) {
  const code = data.code;
  if (code === loginCode) {
    Message.error('登录已过期，请重新登录。');
    router.replace(loginRouter);
  } else {
    Message.error(data.message || '未知错误');
  }
}



// WEBPACK FOOTER //
// ./src/util/http.js